import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AppAcknowledge, AppConfirm } from "../../../utils/PopupUtil";
import API from "../../api/API";
import Cookies from "js-cookie";

/**
 * For logging in as any user in Crititcal situations
 * Only works for Supportal users
 */
export default function useImpersonateUser() {
  const client = useQueryClient();

  const impersonateUser = useMutation({
    mutationFn: ({ user }: { user: any }) => {
      const name = user.Name ? user.Name : user.PrimaryContactEmail;

      return AppConfirm({
        title: `Sign In As ${name}?`,
        text: `Are you sure you want to sign in as this person? You will be logged out and relogged in as ${name}. This feature is designed for critical situations only.`,
        confirmButtonText: "Sign In",
        confirmButtonColor: "var(--primary)",
      })
        .then((result) => {
          if (!result.isConfirmed) return null;

          return API.impersonateUser(user.id);
        })
        .then((result) => {
          return result;
        })
        .catch((error) => {
          if (
            error.response.data.message ===
            "This user doesn't allow impersonating."
          ) {
            AppAcknowledge({
              title: "Not Allowed",
              text: "You are not allowed to impersonate this user.",
              confirmButtonText: "OK",
              confirmButtonColor: "var(--primary)",
            });
          } else {
            AppAcknowledge({
              title: "Error",
              text: "An error occurred while impersonating the user.",
              confirmButtonText: "OK",
              confirmButtonColor: "var(--primary)",
            });
          }
        });
    },
    onSuccess: (data: any) => {
      // Logout current user
      API.deleteSession(Cookies.get("session") || "");
      client.clear();

      Object.keys(Cookies.get()).forEach(function (cookieName) {
        const neededAttributes: any = { sameSite: "strict", secure: true };
        Cookies.remove(cookieName, neededAttributes);
      });

      // Login as selected user
      const { authenticationToken } = data.data.data;

      Cookies.set("authenticationToken", authenticationToken, {
        expires: 7,
        sameSite: "strict",
        secure: window.location.origin.startsWith("https"),
      });

      window.location.href = "/clouds";
    },
    onError: () => {},
  });

  return {
    impersonateUser: impersonateUser.mutate,
    impersonating: impersonateUser.isPending,
  };
}
